import { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_ROUTE_NAME } from '@/libs/route-name';

export const customerRoute = (): RouteRecordRaw => ({
    path: '/manage/customer',
    name: CUSTOMER_ROUTE_NAME.CUSTOMER,
    component: () => import('@/pages/manage/customer/index.vue'),
});

export const customerDetailRoute = (): RouteRecordRaw => ({
    path: '/manage/customer/:id',
    name: CUSTOMER_ROUTE_NAME.CUSTOMER_DETAIL,
    component: () => import('@/pages/manage/customer/customer-detail.vue'),
});

export const customerAddressRoute = (): RouteRecordRaw => ({
    path: '/manage/customer/:id/address',
    name: CUSTOMER_ROUTE_NAME.CUSTOMER_ADDRESS,
    component: () => import('@/pages/manage/customer/customer-address.vue'),
});